export default function moneyFormat(value: number) {
  if (value === null || value === undefined || (value as any) === '') return null;
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
}
